import { IStatus } from 'app/projects/shared/src/lib/interfaces/status.interface';
import { SectionRule } from '../enums/sectionRule.enum';

// @dynamic
export class ModuleStatuses {
    static readonly PLANNED = 'planned';
    static readonly UNPUBLISHED = 'unpublished';
    static readonly PUBLISHED = 'published';
    static readonly RUNNING = 'running';
    static readonly COMPLETED = 'completed';
    static readonly CANCELED = 'canceled';
    static readonly ARCHIVED = 'archived';

    static visibleKeys: string[] = [
        ModuleStatuses.PLANNED,
        ModuleStatuses.UNPUBLISHED,
        ModuleStatuses.PUBLISHED,
        ModuleStatuses.RUNNING,
        ModuleStatuses.COMPLETED,
        ModuleStatuses.ARCHIVED,
    ];

    static all: IStatus[] = [
        {
            name: ModuleStatuses.PLANNED,
            translationLabel: 'MODULE.STATUS.PLANNED',
            possiblePreviousStatusNames: [],
            primaryColor: '#7E8694',
            secundaryColor: '#6E7685',
        },
        {
            name: ModuleStatuses.UNPUBLISHED,
            translationLabel: 'MODULE.STATUS.UNPUBLISHED',
            possiblePreviousStatusNames: [ModuleStatuses.PLANNED, ModuleStatuses.PUBLISHED, ModuleStatuses.RUNNING],
            primaryColor: '#F5A622',
            secundaryColor: '#EDA027',
        },
        {
            name: ModuleStatuses.PUBLISHED,
            translationLabel: 'MODULE.STATUS.PUBLISHED',
            possiblePreviousStatusNames: [ModuleStatuses.UNPUBLISHED, 'pending', ModuleStatuses.RUNNING, ModuleStatuses.CANCELED],
            primaryColor: '#CF7EFF',
            secundaryColor: '#C87BF6',
        },
        {
            name: ModuleStatuses.RUNNING,
            translationLabel: 'GENERAL.STATUS.IN_PROGRESS',
            possiblePreviousStatusNames: [ModuleStatuses.PUBLISHED, ModuleStatuses.COMPLETED, ModuleStatuses.CANCELED],
            primaryColor: '#61B3F2',
            secundaryColor: '#60ADE8',
        },
        {
            name: ModuleStatuses.COMPLETED,
            translationLabel: 'GENERAL.STATUS.COMPLETED',
            possiblePreviousStatusNames: [ModuleStatuses.RUNNING, ModuleStatuses.PUBLISHED, ModuleStatuses.ARCHIVED, ModuleStatuses.CANCELED],
            primaryColor: '#4DDA8D',
            secundaryColor: '#4DD289',
        },
        {
            name: ModuleStatuses.CANCELED, // BC
            translationLabel: 'MODULE.STATUS.CANCELED',
            possiblePreviousStatusNames: [],
            primaryColor: '#EE5568',
            secundaryColor: '#E65466',
        },
        {
            name: ModuleStatuses.ARCHIVED,
            translationLabel: 'MODULE.STATUS.ARCHIVED',
            possiblePreviousStatusNames: [ModuleStatuses.COMPLETED, ModuleStatuses.CANCELED],
            primaryColor: '#ADAFB4',
            secundaryColor: '#A8AAAD',
        },
    ];

    static ruleOpts: {
        dontTrackProgress: string;
        trackProgress: string;
        sequential: string;
    } = {
        dontTrackProgress: SectionRule.Default,
        trackProgress: SectionRule.TrackProgress,
        sequential: SectionRule.Sequential,
    };

    static getNextAvailableStatuses(moduleStatus: string): IStatus[] {
        return ModuleStatuses.all.filter((status) => status.possiblePreviousStatusNames.includes(moduleStatus));
    }
}
